var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _text, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "345.333px",
    height: "108.833px",
    viewBox: "0 -20.833 345.333 108.833",
    enableBackground: "new 0 -20.833 345.333 108.833",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.9536,
    y1: 196.7129,
    x2: 116.9536,
    y2: 162.8164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M95.747,162.816l7.046,0.355v21.822c0,3.24,0.24,5.569,0.633,6.849 c0.494,1.334,1.404,2.545,2.902,3.899c-1.36-0.317-2.534-0.717-3.588-1.529c-1.055-0.776-1.758-1.616-2.12-2.721 c-0.324-1.002-0.49-2.691-0.49-5.113v-15.041c0-2.61-0.351-4.427-1.037-5.69c-0.686-1.194-1.788-1.96-3.347-2.313V162.816z  M128.746,163.172v33.169h-2.952c0.213-0.703,0.305-1.688,0.342-3.021c-3.481,2.228-7.128,3.394-10.94,3.394 c-2.229,0-4.22-0.567-5.88-1.499c-1.71-0.964-2.804-2.233-3.427-3.798c-0.582-1.561-0.92-3.76-0.92-6.644v-21.601 c2.248,0,4.675-0.143,7.294-0.355v0.518c-1.137,0.19-2.079,0.703-2.771,1.399c-0.739,0.761-1.222,1.559-1.44,2.53 c-0.291,0.946-0.387,2.442-0.387,4.499l-0.053,0.649v11.958c0,2.717,0.219,4.621,0.642,5.841c0.37,1.226,1.239,2.228,2.558,3.108 c1.352,0.721,3.028,1.139,5.087,1.139c3.188,0,6.633-1.126,10.239-3.565v-18.338c0-2.349-0.129-4.073-0.342-5.181 c-0.231-1.018-0.658-1.859-1.351-2.596c-0.69-0.636-1.56-1.093-2.693-1.444v-0.518c0.112,0,0.426,0,0.887,0.002 c0.429,0.004,0.939,0.065,1.452,0.164C125.828,163.044,127.394,163.166,128.746,163.172z M132.781,196.341h-1.761v-33.169 c1.573-0.006,2.759-0.093,3.542-0.177l3.599-0.179v0.518c-1.086,0.19-2.036,0.714-2.763,1.5c-0.749,0.767-1.216,1.741-1.469,2.876 c-0.237,1.089-0.299,3.108-0.299,6.151v13.888c0,5.186,1.477,8.028,4.531,8.381v0.583 C135.397,196.457,133.595,196.341,132.781,196.341z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.2427,
    y1: 197.0107,
    x2: 155.2427,
    y2: 173.5107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M146.704,193.786l-0.165,0.254c-3.141-1.847-4.712-4.75-4.712-8.675 c0-1.431,0.268-2.908,0.856-4.314c0.544-1.407,1.752-2.832,3.504-4.273l0.163,0.219c-1.296,2.226-1.931,4.949-1.931,8.2 C144.42,188.471,145.144,191.381,146.704,193.786z M163.772,183.667h-14.571c-0.067,1.07-0.067,1.684-0.067,2.004 c0,2.71,0.734,4.893,2.27,6.574c1.456,1.565,3.405,2.446,5.777,2.446c1.994,0,3.784-0.606,5.348-1.71 c1.576-1.034,2.852-2.418,3.811-4.181h1.334c-1.942,5.484-5.624,8.21-11.031,8.21c-3.223,0-5.768-1.169-7.508-3.341 c-1.738-2.324-2.606-5.19-2.606-8.6c0-3.231,0.801-5.998,2.432-8.24c1.578-2.231,3.702-3.319,6.297-3.319 c2.106,0,3.97,0.808,5.533,2.438C162.35,177.436,163.396,180.127,163.772,183.667z M149.489,181.401h11.137 c-0.063-1.567-0.543-2.882-1.432-4.069c-0.953-1.115-2.24-1.736-3.972-1.736c-1.563,0-2.803,0.533-3.857,1.621 C150.31,178.307,149.659,179.696,149.489,181.401z M168.659,183.667h-2.814c-0.061-3.81-1.054-6.606-2.962-8.415 C166.251,176.672,168.192,179.478,168.659,183.667z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.7817,
    y1: 196.8086,
    x2: 181.7817,
    y2: 173.4219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M172.792,187.972h0.491c0.595,1.884,1.631,3.608,3.11,4.871c1.445,1.253,3.002,1.874,4.719,1.874 c1.285,0,2.453-0.332,3.408-0.982c0.944-0.666,1.373-1.431,1.373-2.318c0-0.926-0.438-1.739-1.425-2.27 c-0.914-0.676-2.688-1.192-5.246-1.735c-2.53-0.562-4.392-1.385-5.642-2.417c-1.24-1.06-1.83-2.417-1.83-3.943 c0-1.274,0.354-2.375,1.211-3.48c-0.102,0.455-0.169,0.982-0.169,1.464c0,1.064,0.342,1.999,0.991,2.858 c0.578,0.986,1.423,1.653,2.489,2.042c1.034,0.471,2.78,1.06,5.249,1.664c2.386,0.493,4.076,1.194,5.164,2.075 c1.052,0.797,1.573,1.95,1.573,3.566c0,1.603-0.683,2.905-2.016,3.974c-1.277,1.004-3.19,1.595-5.666,1.595 c-2.227,0-4.756-0.625-7.615-1.702c0-1.523-0.031-2.704-0.169-3.341c0-0.592-0.047-1.26-0.047-1.996 C172.744,189.36,172.779,188.82,172.792,187.972z M190.725,181.165h-0.395c-0.757-1.984-1.908-3.474-3.551-4.44 c-1.608-0.912-3.215-1.473-4.818-1.473c-1.312,0-2.405,0.344-3.432,0.789c-0.935,0.6-1.399,1.291-1.399,2.303 c0,0.729,0.352,1.256,1.049,1.685c0.691,0.388,1.974,0.781,3.969,1.137c4.03,0.903,6.652,2.028,7.858,3.33 c1.219,1.334,1.809,2.759,1.809,4.306c0,1.221-0.589,2.674-1.775,4.181c0.165-0.678,0.291-1.386,0.291-1.916 c0-1.562-0.555-3.083-1.675-4.39c-1.078-1.326-3.529-2.461-7.522-3.418c-2.281-0.523-3.924-1.096-4.846-1.752 c-0.88-0.702-1.373-1.729-1.373-3.125c0-1.461,0.667-2.762,2.05-3.623c1.371-0.896,3.305-1.336,5.93-1.336 c2.531,0,5.053,0.445,7.682,1.482c-0.042,0.538-0.042,0.785-0.042,0.891c0,0.809,0.01,1.537,0.147,2.459 C190.698,179.034,190.725,179.96,190.725,181.165z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.4287,
    y1: 196.7129,
    x2: 206.4287,
    y2: 167.3135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M198.555,188.165v-11.632h-1.968v-0.244l4.332-4.163v17.942c0,2.04,0.219,3.479,0.563,4.316 c0.412,0.722,0.975,1.396,1.66,1.745c-1.705-0.037-2.892-0.705-3.576-1.812C198.871,193.177,198.555,191.186,198.555,188.165z  M205.314,167.313v7.005h5.388c1.021,0,1.738-0.102,2.257-0.301c0.515-0.197,1.178-0.702,1.913-1.422h0.731 c-1.261,1.794-2.142,2.937-2.718,3.353c-0.52,0.341-1.313,0.585-2.359,0.585h-5.212v11.938c0,1.802,0.14,3.109,0.341,3.774 c0.166,0.633,0.523,1.121,1.216,1.671c0.636,0.469,1.572,0.702,2.729,0.702c2.327,0,4.333-1.109,6.003-3.358l0.668,0.402 c-1.725,3.41-4.185,5.051-7.482,5.051c-1.384,0-2.591-0.289-3.484-0.933c-1.013-0.708-1.626-1.396-1.926-2.448 c-0.323-0.985-0.497-2.439-0.497-4.184v-18.978C203.748,169.285,204.617,168.312,205.314,167.313z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.1563,
    y1: 196.8281,
    x2: 233.1563,
    y2: 173.2139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M224.489,175.495c-1.976,2.193-2.913,5.314-2.913,9.499c0,4.19,0.938,7.481,2.913,9.723 c-3.633-2.078-5.453-5.283-5.453-9.767C219.036,180.457,220.856,177.332,224.489,175.495z M223.725,185.35 c0-4.092,0.798-7.078,2.468-9.061c1.695-2.072,3.982-3.075,6.952-3.075c2.702,0,4.956,0.938,6.737,2.734 c1.779,1.74,2.67,4.696,2.67,8.771c0,4.484-0.967,7.631-2.868,9.441c-1.94,1.847-4.116,2.667-6.697,2.667 c-2.555,0-4.701-0.893-6.539-2.788C224.605,192.228,223.725,189.257,223.725,185.35z M226.344,184.847 c0,3.849,0.574,6.394,1.738,7.792c1.229,1.401,2.847,2.078,5.063,2.078c2.002,0,3.624-0.677,4.894-2.12 c1.237-1.44,1.885-4.126,1.885-7.877c0-6.339-2.264-9.469-6.778-9.469C228.607,175.251,226.344,178.381,226.344,184.847z  M241.809,194.385c1.921-2.12,2.874-5.236,2.874-9.035c0-2.092-0.253-4.001-0.673-5.859c-0.495-1.802-1.238-3.201-2.201-4.048 c3.667,2.005,5.467,5.13,5.467,9.352C247.275,188.827,245.476,192.012,241.809,194.385z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.4082,
    y1: 215.9873,
    x2: 266.4082,
    y2: 173.4219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M256.822,173.861v41.754l-2.448,0.286c0.076-3.108,0.12-6.506,0.12-10.046v-24.454 c0-1.858-0.044-3.165-0.225-4.069c-0.161-0.691-0.529-1.384-1.228-2.08c-0.657-0.584-1.458-1.018-2.492-1.143v-0.599 c0.748,0,1.768,0.089,3.049,0.261C254.845,173.861,255.934,173.861,256.822,173.861z M259.029,215.615v-41.754 c1.126-0.006,1.951-0.059,2.446-0.09c-0.071,0.776-0.124,1.479-0.142,1.971c2.131-1.53,4.224-2.32,6.368-2.32 c3.158,0,5.616,1.126,7.323,3.408c1.703,2.242,2.654,5.041,2.654,8.313c0,3.255-0.986,6.03-2.849,8.293 c-1.96,2.344-4.451,3.5-7.804,3.5c-1.787,0-3.687-0.479-5.693-1.351v12.719c0,1.938,0.105,3.292,0.387,4.153 c0.247,0.707,0.786,1.417,1.706,2.092c0.814,0.579,2.074,0.896,3.556,1.002v0.436h-0.795c-0.477,0-1.307-0.053-2.66-0.064 C262.081,215.741,260.608,215.631,259.029,215.615z M261.334,178.452v14.814c1.526,1.036,3.351,1.45,5.45,1.45 c2.259,0,4.286-0.677,5.816-2.406c1.681-1.557,2.362-3.968,2.362-7.22c0-3.007-0.682-5.377-2.092-7.081 c-1.385-1.721-3.123-2.612-5.144-2.612C265.322,175.397,263.21,176.416,261.334,178.452z M276.978,194.405l-0.282-0.32 c2.091-2.038,3.107-5.057,3.107-9.091c0-3.736-1.017-6.847-3.107-9.398l0.282-0.153c3.555,2.302,5.289,5.482,5.289,9.508 c0,1.79-0.363,3.673-1.388,5.521C279.947,192.304,278.655,193.618,276.978,194.405z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.4902,
    y1: 197.0107,
    x2: 299.4902,
    y2: 173.5107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M290.963,193.786l-0.121,0.254c-3.183-1.847-4.74-4.75-4.74-8.675c0-1.431,0.298-2.908,0.785-4.314 c0.6-1.407,1.756-2.832,3.605-4.273l0.108,0.219c-1.343,2.226-1.991,4.949-1.991,8.2 C288.609,188.471,289.414,191.381,290.963,193.786z M308.017,183.667h-14.611c-0.004,1.07-0.004,1.684-0.004,2.004 c0,2.71,0.678,4.893,2.205,6.574c1.546,1.565,3.418,2.446,5.787,2.446c2.068,0,3.822-0.606,5.405-1.71 c1.548-1.034,2.886-2.418,3.743-4.181h1.32c-1.827,5.484-5.576,8.21-10.932,8.21c-3.321,0-5.783-1.169-7.529-3.341 c-1.73-2.324-2.664-5.19-2.664-8.6c0-3.231,0.881-5.998,2.469-8.24c1.58-2.231,3.672-3.319,6.352-3.319 c2.079,0,3.928,0.808,5.521,2.438C306.601,177.436,307.67,180.127,308.017,183.667z M293.763,181.401h11.107 c-0.023-1.567-0.601-2.882-1.387-4.069c-1.026-1.115-2.325-1.736-4.031-1.736c-1.536,0-2.829,0.533-3.898,1.621 C294.514,178.307,293.919,179.696,293.763,181.401z M312.878,183.667h-2.793c-0.002-3.81-1.03-6.606-2.936-8.415 C310.455,176.672,312.48,179.478,312.878,183.667z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.2871,
    y1: 196.8838,
    x2: 332.2871,
    y2: 157.9414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M322.163,175.884c-2.285,2.212-3.355,5.518-3.355,9.77c0,3.495,1.07,6.65,3.355,9.606 c-4.027-2.469-5.973-5.756-5.973-10.011C316.19,180.625,318.136,177.5,322.163,175.884z M339.669,158.295v38.046 c-1.25,0.067-2.092,0.116-2.621,0.116c0.093-0.666,0.127-1.298,0.127-1.891c-2.052,1.563-4.185,2.317-6.552,2.317 c-3.13,0-5.511-1.104-7.142-3.266c-1.671-2.324-2.603-4.902-2.603-7.947c0-3.251,0.951-6.105,2.654-8.507 c1.704-2.39,4.445-3.653,8.187-3.653c2.04,0,3.973,0.491,5.628,1.394v-10.149c0-1.937-0.247-3.326-0.809-4.341 c-0.69-0.911-1.73-1.604-3.16-1.941v-0.531C335.452,158.117,337.56,158.227,339.669,158.295z M337.348,185.599v-8.575 c-1.863-1.072-3.652-1.528-5.575-1.528c-2.561,0-4.626,0.808-6.061,2.618c-1.477,1.794-2.23,4.201-2.23,7.236 c0,2.77,0.667,5.033,2.001,6.844c1.303,1.847,3.049,2.723,5.256,2.723c2.323,0,4.385-0.876,6.478-2.723 C337.24,190.211,337.348,188.048,337.348,185.599z M342.813,196.341h-1.052v-38.046c0.677,0,1.562-0.031,2.707-0.177 c-0.3,3.83-0.372,7.641-0.372,11.42v19.509c0,1.811,0.072,3.01,0.298,3.849c0.157,0.793,0.688,1.489,1.424,2.146 c0.74,0.596,1.53,0.999,2.564,1.088v0.583C346.169,196.457,344.255,196.341,342.813,196.341z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.2637,
    y1: 196.7646,
    x2: 360.2637,
    y2: 160.2656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M355.208,163.432l4.389,4.13l-1.503,1.534l-4.387-4.041L355.208,163.432z M353.923,188.471v-14.609 h2.427v15.675c0,2.411,0.226,4.012,0.704,4.978c0.346,1.033,1.085,1.774,2.117,2.251h-0.945c-1.405-0.635-2.479-1.551-3.251-2.725 C354.284,192.98,353.923,191.139,353.923,188.471z M358.094,160.266l4.459,4.13l-1.528,1.544l-4.379-4.047L358.094,160.266z  M358.438,189.047v-15.186h2.339v15.643c0,3.828,1.318,5.71,3.938,5.71c0.93,0,1.614-0.142,2.104-0.497v0.708 c-1.084,0.863-2.161,1.34-3.489,1.34c-1.146,0-2.092-0.341-2.924-1.074c-0.916-0.739-1.422-1.605-1.622-2.424 C358.471,192.311,358.438,190.893,358.438,189.047z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.4082,
    y1: 196.7129,
    x2: 381.4082,
    y2: 173.5107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CE1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CC1E16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#C51D15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#BA1B14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#A91912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#931510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#77110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#570D09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#310705"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#080101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#000000"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M373.516,184.847c-1.299,1.63-1.948,3.461-1.948,5.391c0,2.401,0.793,4.259,2.476,5.804 c-1.354-0.264-2.405-0.969-3.429-2.001c-1.038-0.937-1.544-2.127-1.544-3.75C369.07,187.619,370.614,185.74,373.516,184.847z  M383.309,183.771v-3.314c0-1.518-0.28-2.766-0.865-3.537c-0.708-0.914-1.893-1.324-3.708-1.324c-2.846,0-5.183,1.045-7.066,3.149 l-0.772-0.72c0.772-1.336,1.95-2.43,3.586-3.216c1.684-0.866,3.432-1.299,5.221-1.299c3.988,0,5.873,2.141,5.873,6.467v16.363 c-0.93,0.067-1.748,0.116-2.427,0.372l0.159-1.641c-1.054,1.058-2.25,1.641-3.692,1.641c-1.702,0-3.086-0.601-4.146-1.996 c-1.18-1.298-1.709-2.77-1.709-4.406c0-1.84,0.677-3.492,2.092-4.816c1.323-1.3,3.114-1.968,5.274-1.968 C381.862,183.526,382.569,183.609,383.309,183.771z M383.309,193.688v-8.194c-0.702-0.129-1.229-0.145-1.777-0.145 c-1.604,0-2.909,0.547-3.902,1.517c-0.859,1.035-1.369,2.28-1.369,3.552c0,1.178,0.42,2.221,1.229,3.019 c0.771,0.948,1.777,1.28,2.862,1.28C381.392,194.717,382.379,194.385,383.309,193.688z M393.747,196.713l-6.079-0.372v-16.313 c0-1.647-0.089-2.915-0.387-3.739c-0.368-0.693-0.997-1.385-1.899-2.004c1.847,0.349,3.006,0.967,3.671,2.004 c0.708,0.965,1.051,2.688,1.051,5.217v9.688c0,1.632,0.217,2.846,0.678,3.522c0.366,0.708,1.385,1.151,2.966,1.413V196.713z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#CE1E16",
    d: "M97.99,159.668c-0.861-13.533-5.308-23.407-12.925-31.009 c-7.008-6.997-17.371-12.911-30.695-12.924c-21.068-0.179-35.936,13.396-37.402,32.245c-1.864,24.835,20.684,44.599,47.152,35.833 c-6.184-13.637-9.125-33.317-24.337-39.038c36.568-1.618,27.181,52.007,61.717,55.679c-11.464,2.859-24.296-0.289-29.701-6.582 c-31.816,14.488-64.882-7.809-67.158-37.946c-2.57-34.076,30.416-62.031,64.883-48.143 C88.004,115.179,101.595,135.507,97.99,159.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#161616",
    d: "M87.246,178.778c6.471-27.747-14.113-53.628-42.432-51.655 c-7.161,0.455-12.566,2.577-17.971,5.99c6.026-7.705,18.065-12.604,30.708-11.688C83.844,123.27,101.016,153.449,87.246,178.778z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 453.0791 66.666)",
    fontFamily: "'Roboto-Black'",
    fontSize: 50
  }, "UESTOPEDIA")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M111.558,72.988c-0.82,1.4-1.862,2.47-3.127,3.227c-1.264,0.76-2.715,1.138-4.356,1.138 c-2.811,0-5.004-0.903-6.589-2.7c-1.584-1.797-2.375-4.59-2.375-8.386V50.188h7.164v16.167c0,1.939,0.33,3.338,0.984,4.184 c0.659,0.847,1.629,1.268,2.908,1.268c1.15,0,2.134-0.183,2.955-0.552c0.821-0.371,1.495-0.917,2.02-1.643V50.188h7.191v26.644 H112.2L111.558,72.988z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M135.543,77.353c-3.841,0-6.91-1.233-9.208-3.694c-2.301-2.466-3.449-5.592-3.449-9.388v-0.982 c0-3.956,1.087-7.214,3.265-9.777c2.174-2.562,5.091-3.833,8.752-3.816c3.596,0,6.387,1.086,8.372,3.249 c1.989,2.171,2.983,5.102,2.983,8.795v3.913h-15.912l-0.045,0.149c0.129,1.747,0.715,3.187,1.758,4.313 c1.043,1.129,2.458,1.691,4.247,1.691c1.595,0,2.915-0.157,3.966-0.477c1.05-0.32,2.198-0.828,3.446-1.518l1.947,4.444 c-1.083,0.889-2.505,1.629-4.263,2.215C139.647,77.058,137.695,77.353,135.543,77.353z M134.903,55.234 c-1.329,0-2.38,0.512-3.15,1.53c-0.772,1.019-1.25,2.355-1.428,4.014l0.072,0.121h8.817v-0.64c0-1.526-0.358-2.748-1.074-3.659 C137.429,55.691,136.347,55.234,134.903,55.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M164.85,69.492c0-0.788-0.382-1.467-1.147-2.039c-0.763-0.58-2.178-1.084-4.248-1.529 c-3.15-0.641-5.528-1.59-7.129-2.843c-1.598-1.261-2.401-2.969-2.401-5.137c0-2.299,0.965-4.247,2.895-5.849 c1.927-1.6,4.511-2.401,7.744-2.401c3.398,0,6.104,0.798,8.114,2.391c2.012,1.592,2.978,3.603,2.894,6.033l-0.048,0.144h-6.946 c0-1.065-0.34-1.934-1.022-2.608c-0.68-0.673-1.676-1.009-2.991-1.009c-1.166,0-2.081,0.283-2.746,0.853 c-0.664,0.564-0.997,1.276-0.997,2.125c0,0.823,0.351,1.498,1.048,2.022c0.696,0.522,2.113,0.992,4.246,1.404 c3.283,0.656,5.724,1.621,7.316,2.892c1.59,1.271,2.387,3.025,2.387,5.256c0,2.397-1.026,4.356-3.079,5.876 c-2.053,1.52-4.761,2.28-8.125,2.28c-3.548,0-6.351-0.903-8.409-2.7c-2.062-1.797-3.042-3.848-2.945-6.146l0.05-0.144h6.577 c0.048,1.423,0.514,2.459,1.402,3.099c0.888,0.642,2.044,0.967,3.472,0.967c1.331,0,2.345-0.27,3.041-0.791 C164.501,71.114,164.85,70.398,164.85,69.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M184.992,43.662v6.525h4.485v5.047h-4.485v13.566c0,1.036,0.213,1.774,0.641,2.219 c0.427,0.441,1,0.669,1.724,0.669c0.378,0,0.702-0.022,0.972-0.064c0.27-0.042,0.586-0.112,0.948-0.208l0.614,5.193 c-0.718,0.248-1.424,0.432-2.115,0.554c-0.688,0.126-1.438,0.189-2.244,0.189c-2.478,0-4.381-0.684-5.723-2.046 c-1.337-1.362-2.006-3.526-2.006-6.479V55.234h-3.891v-5.047h3.891v-6.525H184.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M192.945,63.264c0-3.975,1.11-7.229,3.324-9.762c2.217-2.539,5.285-3.808,9.209-3.808 c3.944,0,7.025,1.263,9.263,3.796c2.231,2.524,3.346,5.783,3.346,9.773v0.517c0,4.01-1.11,7.271-3.337,9.788 c-2.224,2.523-5.3,3.784-9.221,3.784c-3.94,0-7.024-1.261-9.249-3.784c-2.222-2.518-3.335-5.778-3.335-9.788V63.264z  M200.113,63.771c0,2.424,0.423,4.367,1.281,5.836c0.852,1.471,2.23,2.199,4.136,2.199c1.855,0,3.215-0.732,4.077-2.211 c0.858-1.477,1.291-3.419,1.291-5.824v-0.519c0-2.361-0.437-4.286-1.306-5.776c-0.869-1.494-2.239-2.241-4.113-2.241 c-1.854,0-3.211,0.749-4.072,2.253c-0.866,1.497-1.293,3.418-1.293,5.765V63.771z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M246.556,64.248c0,3.938-0.908,7.112-2.734,9.508c-1.825,2.396-4.369,3.597-7.634,3.597 c-1.396,0-2.633-0.264-3.719-0.777c-1.083-0.515-2.012-1.276-2.78-2.278v12.777h-7.168V50.188h6.477l0.417,3.15 c0.789-1.16,1.738-2.064,2.848-2.695c1.105-0.631,2.401-0.948,3.877-0.948c3.297,0,5.857,1.29,7.683,3.864 c1.826,2.582,2.734,5.969,2.734,10.175V64.248z M239.363,63.696c0-2.52-0.416-4.554-1.255-6.117 c-0.836-1.564-2.116-2.345-3.841-2.345c-1.084,0-2.006,0.227-2.772,0.665c-0.763,0.447-1.366,1.079-1.807,1.905V69.49 c0.44,0.756,1.044,1.33,1.807,1.727c0.767,0.394,1.704,0.589,2.822,0.589c1.737,0,3.016-0.682,3.829-2.043 c0.814-1.363,1.217-3.216,1.217-5.554V63.696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M262.784,77.353c-3.846,0-6.909-1.233-9.211-3.694c-2.297-2.466-3.447-5.592-3.447-9.388v-0.982 c0-3.956,1.089-7.214,3.265-9.777c2.174-2.562,5.092-3.833,8.752-3.816c3.598,0,6.39,1.086,8.375,3.249 c1.985,2.171,2.981,5.102,2.981,8.795v3.913h-15.91l-0.047,0.149c0.123,1.747,0.717,3.187,1.755,4.313 c1.046,1.129,2.459,1.691,4.253,1.691c1.59,0,2.912-0.157,3.962-0.477c1.049-0.32,2.2-0.828,3.445-1.518l1.945,4.444 c-1.078,0.889-2.503,1.629-4.258,2.215C266.89,77.058,264.935,77.353,262.784,77.353z M262.143,55.234 c-1.326,0-2.38,0.512-3.153,1.53c-0.77,1.019-1.247,2.355-1.423,4.014l0.067,0.121h8.82v-0.64c0-1.526-0.355-2.748-1.075-3.659 C264.666,55.691,263.587,55.234,262.143,55.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M276.57,63.733c0-4.206,0.913-7.593,2.726-10.175c1.813-2.574,4.369-3.864,7.67-3.864 c1.331,0,2.526,0.287,3.593,0.86c1.067,0.578,2.004,1.396,2.81,2.466V38.416h7.217v38.416h-6.18l-0.597-3.25 c-0.836,1.229-1.822,2.172-2.968,2.81c-1.137,0.638-2.447,0.962-3.926,0.962c-3.266,0-5.806-1.201-7.619-3.597 c-1.813-2.396-2.726-5.569-2.726-9.508V63.733z M283.742,64.252c0,2.347,0.395,4.194,1.18,5.535 c0.79,1.348,2.069,2.019,3.842,2.019c1.035,0,1.938-0.207,2.712-0.632c0.766-0.416,1.396-1.036,1.893-1.844V57.909 c-0.496-0.839-1.119-1.496-1.886-1.969c-0.758-0.468-1.654-0.706-2.669-0.706c-1.755,0-3.039,0.785-3.854,2.354 c-0.811,1.568-1.218,3.615-1.218,6.146V64.252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M313.711,43.812h-7.195v-5.396h7.195V43.812z M313.711,76.831h-7.195V50.188h7.195V76.831z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M335.259,76.831c-0.266-0.608-0.492-1.246-0.675-1.919c-0.194-0.675-0.324-1.361-0.409-2.07 c-0.739,1.295-1.71,2.374-2.917,3.23c-1.208,0.851-2.649,1.28-4.324,1.28c-2.793,0-4.94-0.723-6.454-2.158 c-1.506-1.437-2.262-3.397-2.262-5.872c0-2.611,1.004-4.633,3.016-6.073c2.01-1.436,4.944-2.148,8.802-2.148h4.015v-2.121 c0-1.28-0.336-2.273-1.009-2.981c-0.677-0.706-1.666-1.058-2.979-1.058c-1.164,0-2.062,0.281-2.701,0.851 c-0.63,0.565-0.943,1.352-0.943,2.354l-6.944-0.027l-0.025-0.149c-0.112-2.248,0.866-4.189,2.931-5.822 c2.065-1.633,4.785-2.452,8.152-2.452c3.183,0,5.769,0.812,7.758,2.426c1.986,1.618,2.978,3.919,2.978,6.909v11.007 c0,1.248,0.091,2.421,0.285,3.521c0.185,1.102,0.487,2.196,0.898,3.274H335.259z M328.68,72.034c1.268,0,2.389-0.313,3.376-0.937 c0.985-0.63,1.648-1.348,1.994-2.172v-3.769h-4.015c-1.523,0-2.686,0.383-3.471,1.147c-0.788,0.764-1.184,1.688-1.184,2.774 c0,0.883,0.293,1.599,0.891,2.138C326.863,71.763,327.664,72.034,328.68,72.034z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#CE1E16",
    d: "M96.553,39.174c-0.869-13.65-5.354-23.61-13.035-31.279 C76.448,0.838,65.996-5.127,52.557-5.139C31.305-5.32,16.309,8.372,14.831,27.386c-1.879,25.05,20.863,44.985,47.561,36.145 c-6.24-13.757-9.205-33.606-24.549-39.379c36.887-1.631,27.418,52.456,62.253,56.16c-11.567,2.883-24.509-0.29-29.96-6.636 C38.043,88.287,4.691,65.801,2.396,35.396C-0.194,1.027,33.076-27.17,67.842-13.16C86.481-5.702,100.189,14.803,96.553,39.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#161616",
    d: "M85.715,58.448c6.527-27.986-14.235-54.092-42.798-52.1 c-7.223,0.457-12.676,2.599-18.128,6.04C30.869,4.616,43.012-0.323,55.765,0.601C82.286,2.458,99.606,32.902,85.715,58.448z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 37.162,
    y: 63.143,
    width: 385.092,
    height: 57.244
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_12_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M111.429,73.075c-0.821,1.4-1.862,2.469-3.128,3.225c-1.263,0.757-2.716,1.134-4.357,1.134 c-2.809,0-5.002-0.899-6.59-2.695c-1.582-1.802-2.373-4.592-2.373-8.386V50.271h7.164v16.168c0,1.941,0.327,3.337,0.984,4.184 c0.659,0.849,1.627,1.27,2.908,1.27c1.147,0,2.134-0.183,2.955-0.552c0.821-0.373,1.493-0.919,2.02-1.644V50.271h7.192v26.646 h-6.131L111.429,73.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M135.414,77.434c-3.843,0-6.912-1.233-9.208-3.693c-2.301-2.464-3.451-5.59-3.451-9.384V63.37 c0-3.953,1.089-7.21,3.264-9.775c2.176-2.559,5.094-3.831,8.755-3.815c3.593,0,6.387,1.084,8.372,3.249 c1.987,2.17,2.981,5.101,2.981,8.794v3.915h-15.909l-0.048,0.146c0.131,1.75,0.717,3.19,1.761,4.314 c1.043,1.132,2.458,1.694,4.247,1.694c1.592,0,2.915-0.158,3.966-0.478c1.049-0.32,2.198-0.828,3.447-1.516l1.944,4.443 c-1.08,0.889-2.502,1.629-4.259,2.214C139.519,77.142,137.564,77.434,135.414,77.434z M134.774,55.32 c-1.331,0-2.383,0.51-3.152,1.528c-0.771,1.018-1.25,2.357-1.428,4.016l0.074,0.118h8.817v-0.64c0-1.523-0.357-2.747-1.073-3.658 C137.298,55.775,136.218,55.32,134.774,55.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M164.721,69.576c0-0.785-0.382-1.469-1.149-2.04c-0.761-0.578-2.176-1.085-4.245-1.528 c-3.153-0.64-5.529-1.59-7.129-2.843c-1.598-1.259-2.4-2.966-2.4-5.136c0-2.298,0.965-4.248,2.892-5.848 c1.93-1.6,4.511-2.402,7.746-2.402c3.398,0,6.105,0.799,8.114,2.39c2.01,1.592,2.978,3.604,2.894,6.035l-0.051,0.144h-6.944 c0-1.067-0.34-1.937-1.022-2.609c-0.681-0.673-1.679-1.008-2.991-1.008c-1.168,0-2.081,0.281-2.745,0.849 c-0.667,0.568-0.999,1.278-0.999,2.129c0,0.823,0.349,1.498,1.049,2.019c0.694,0.524,2.113,0.994,4.246,1.406 c3.282,0.656,5.722,1.62,7.313,2.892c1.592,1.271,2.391,3.027,2.391,5.259c0,2.397-1.026,4.355-3.079,5.875 c-2.054,1.516-4.762,2.275-8.128,2.275c-3.545,0-6.351-0.899-8.408-2.695c-2.061-1.802-3.042-3.848-2.943-6.146l0.05-0.146h6.575 c0.048,1.425,0.515,2.46,1.404,3.101c0.886,0.642,2.044,0.963,3.472,0.963c1.328,0,2.342-0.266,3.041-0.787 C164.371,71.196,164.721,70.484,164.721,69.576z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M184.864,43.746v6.525h4.483v5.05h-4.483v13.566c0,1.036,0.212,1.774,0.638,2.22 c0.427,0.44,1.002,0.664,1.725,0.664c0.377,0,0.703-0.019,0.97-0.062c0.272-0.041,0.585-0.113,0.951-0.207l0.613,5.193 c-0.72,0.247-1.424,0.432-2.115,0.555c-0.69,0.124-1.438,0.184-2.244,0.184c-2.478,0-4.383-0.68-5.723-2.045 c-1.338-1.359-2.005-3.521-2.005-6.477V55.32h-3.892v-5.05h3.892v-6.525H184.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M192.815,63.35c0-3.976,1.108-7.229,3.324-9.764c2.217-2.538,5.286-3.807,9.21-3.807 c3.941,0,7.024,1.264,9.262,3.795c2.232,2.526,3.346,5.785,3.346,9.775v0.518c0,4.007-1.109,7.27-3.338,9.788 c-2.224,2.521-5.3,3.778-9.221,3.778c-3.938,0-7.021-1.257-9.246-3.778c-2.225-2.519-3.337-5.781-3.337-9.788V63.35z  M199.984,63.854c0,2.422,0.424,4.368,1.281,5.839c0.849,1.467,2.231,2.198,4.134,2.198c1.855,0,3.217-0.734,4.079-2.211 c0.856-1.477,1.289-3.421,1.289-5.826v-0.517c0-2.362-0.437-4.286-1.304-5.777c-0.869-1.495-2.239-2.24-4.113-2.24 c-1.854,0-3.213,0.749-4.072,2.253c-0.866,1.495-1.294,3.416-1.294,5.765V63.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M246.429,64.332c0,3.941-0.912,7.11-2.738,9.508c-1.823,2.394-4.367,3.594-7.633,3.594 c-1.395,0-2.634-0.257-3.719-0.776c-1.085-0.513-2.012-1.277-2.778-2.275v12.777h-7.169V50.271h6.478l0.416,3.152 c0.789-1.159,1.735-2.064,2.848-2.696c1.104-0.631,2.399-0.947,3.875-0.947c3.3,0,5.859,1.289,7.683,3.865 c1.826,2.579,2.738,5.967,2.738,10.171V64.332z M239.232,63.78c0-2.517-0.416-4.552-1.254-6.119 c-0.834-1.561-2.114-2.341-3.841-2.341c-1.083,0-2.005,0.225-2.771,0.663c-0.763,0.445-1.369,1.079-1.807,1.903v11.686 c0.438,0.761,1.044,1.333,1.807,1.729c0.766,0.394,1.701,0.591,2.821,0.591c1.736,0,3.015-0.686,3.826-2.045 c0.816-1.361,1.218-3.214,1.218-5.552V63.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M262.654,77.434c-3.846,0-6.909-1.233-9.207-3.693c-2.303-2.464-3.453-5.59-3.453-9.384V63.37 c0-3.953,1.09-7.21,3.266-9.775c2.179-2.559,5.096-3.831,8.756-3.815c3.594,0,6.387,1.084,8.372,3.249 c1.983,2.17,2.981,5.101,2.981,8.794v3.915h-15.908l-0.05,0.146c0.128,1.75,0.718,3.19,1.76,4.314 c1.04,1.132,2.459,1.694,4.248,1.694c1.59,0,2.912-0.158,3.966-0.478c1.044-0.32,2.195-0.828,3.442-1.516l1.944,4.443 c-1.079,0.889-2.498,1.629-4.258,2.214C266.759,77.142,264.804,77.434,262.654,77.434z M262.016,55.32 c-1.33,0-2.384,0.51-3.158,1.528c-0.768,1.018-1.246,2.357-1.423,4.016l0.073,0.118h8.814v-0.64c0-1.523-0.354-2.747-1.07-3.658 C264.54,55.775,263.456,55.32,262.016,55.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M276.443,63.815c0-4.204,0.908-7.592,2.723-10.171c1.812-2.576,4.369-3.865,7.669-3.865 c1.331,0,2.526,0.285,3.593,0.861c1.071,0.578,2.007,1.396,2.813,2.465V38.5h7.213v38.416h-6.179l-0.598-3.25 c-0.831,1.23-1.821,2.168-2.963,2.81c-1.141,0.638-2.449,0.958-3.931,0.958c-3.265,0-5.807-1.2-7.618-3.594 c-1.814-2.397-2.723-5.566-2.723-9.508V63.815z M283.612,64.337c0,2.346,0.395,4.192,1.18,5.534 c0.789,1.346,2.068,2.021,3.846,2.021c1.031,0,1.934-0.209,2.707-0.632c0.767-0.416,1.4-1.038,1.896-1.844V57.995 c-0.496-0.841-1.124-1.497-1.889-1.971c-0.759-0.466-1.656-0.704-2.665-0.704c-1.76,0-3.044,0.784-3.858,2.352 c-0.811,1.57-1.217,3.619-1.217,6.146V64.337z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M313.581,43.896h-7.196V38.5h7.196V43.896z M313.581,76.916h-7.196V50.271h7.196V76.916z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE1E16",
    d: "M335.128,76.916c-0.265-0.608-0.488-1.246-0.675-1.923c-0.19-0.669-0.324-1.358-0.408-2.069 c-0.739,1.3-1.712,2.377-2.919,3.235c-1.207,0.846-2.644,1.274-4.318,1.274c-2.794,0-4.941-0.719-6.458-2.154 c-1.508-1.436-2.263-3.397-2.263-5.871c0-2.611,1.008-4.633,3.021-6.072c2.01-1.437,4.944-2.153,8.797-2.153h4.015v-2.121 c0-1.276-0.337-2.269-1.009-2.979c-0.677-0.706-1.667-1.06-2.979-1.06c-1.163,0-2.06,0.283-2.695,0.854 c-0.635,0.563-0.949,1.35-0.949,2.353l-6.943-0.025l-0.025-0.152c-0.113-2.247,0.866-4.187,2.931-5.819 c2.069-1.634,4.786-2.453,8.152-2.453c3.182,0,5.769,0.812,7.758,2.427c1.986,1.616,2.981,3.919,2.981,6.907v11.009 c0,1.244,0.092,2.415,0.28,3.521c0.19,1.101,0.487,2.191,0.898,3.273H335.128z M328.55,72.115c1.267,0,2.392-0.311,3.374-0.935 c0.986-0.628,1.65-1.345,1.995-2.169v-3.771h-4.015c-1.523,0-2.682,0.383-3.466,1.148c-0.79,0.765-1.188,1.689-1.188,2.772 c0,0.886,0.297,1.598,0.891,2.139C326.731,71.846,327.532,72.115,328.55,72.115z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f4cb58b5d4f54069e49d3f15f40af23b.svg";
export { ForwardRef as ReactComponent };